import * as React from 'react';

import {
  DateTime,
} from 'luxon';
import {
  useMotionValue,
  useSpring,
} from 'framer-motion';
import Skeleton from 'react-loading-skeleton';

import {
  Colors,
  Lang,

  Text,
  Title,
} from '@bluecurrent/web-component-lib';

import handleCurrencyFormat from '../../../../../../../../functions/handleCurrencyFormat';

import useGraphStore from '../../stores/useGraphStore';

export default function Price({
  data,
  isLoading,
}) {
  const { _, i18n } = Lang.useTranslation();

  const value = useMotionValue(0);
  const spring = useSpring(value, {
    duration: 300,
  });

  const CURRENT_HOUR = DateTime.now().setLocale(i18n.language).toFormat('HH');
  const CURRENT_DAY = DateTime.now().setLocale(i18n.language).toFormat('yyyy-MM-dd');

  const currentPrice = isLoading
    ? 0
    : data.find((item) => item.hour === CURRENT_HOUR && item.day === CURRENT_DAY).amount ?? 0;

  const hoverPrice = useGraphStore((state) => state.price);
  const hoverDate = useGraphStore((state) => state.date);
  const hoverTime = useGraphStore((state) => state.time);

  const [price, setPrice] = React.useState(0);
  const [time, setTime] = React.useState('--:-- - --:--');
  const [date, setDate] = React.useState('--');

  React.useEffect(() => {
    value.set(hoverPrice === null ? currentPrice : hoverPrice);
  }, [
    data,
    hoverPrice,
    currentPrice,
    isLoading,
  ]);

  React.useEffect(() => {
    if (
      hoverDate === null
      || hoverTime === null
      || hoverDate === undefined
      || hoverTime === undefined
    ) {
      setTime(`${DateTime.now().setLocale(i18n.language).toFormat('HH')}:00 - ${DateTime.now().plus({ hours: 1 }).setLocale(i18n.language).toFormat('HH')}:00`);
      setDate(_('today', { ns: 'dates' }));
    } else {
      const hour = DateTime.fromFormat(String(hoverTime), 'H').setLocale(i18n.language);
      const upcomingHour = hour.plus({ hours: 1 });

      setTime(`${hour.toFormat('HH')}:00 - ${upcomingHour.toFormat('HH')}:00`);
      setDate(
        DateTime.fromFormat(hoverDate, 'y-L-d').hasSame(DateTime.now(), 'day')
          ? _('today', { ns: 'dates' })
          : DateTime.fromFormat(hoverDate, 'y-L-d').setLocale(i18n.language).toFormat('DDD'),
      );
    }
  }, [
    hoverDate,
    hoverTime,
  ]);

  React.useEffect(() => {
    spring.onChange((latest) => {
      setPrice(latest);
    });
  }, [spring]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        position: 'absolute',
        backgroundColor: Colors.WHITE,
        zIndex: 1,
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: isLoading ? -2 : 3,
        height: 100,
        maxHeight: 100,
        top: 24,
        left: 15,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
      }}
    >
      {
        isLoading && (
          <>
            <Skeleton
              height={20}
              width={200}
            />
            <Skeleton
              height={40}
              width={130}
            />
          </>
        )
      }
      {
        !isLoading && (
          <>
            <Text
              fontSize="1em"
              color={Colors.DARK_GREY}
            >
              {`${date}, ${time}`}
            </Text>
            <Title
              fontSize="2.6em"
            >
              { handleCurrencyFormat(i18n, Number(price), 'EUR', 3) }
            </Title>
          </>
        )
      }
    </div>
  );
}
